import React from 'react';
import { Segmented } from 'antd';
import { DesktopOutlined, MoonOutlined, SunOutlined } from '@ant-design/icons';
import styled from '../../../~reusables/contexts/ThemeContext';
import {
  useThemeMode,
  type ThemeMode,
} from '../../../~reusables/contexts/ThemeModeContext';

// The icons' labels name the options; they'd otherwise read as the icon names
const THEME_OPTIONS = [
  {
    value: 'system',
    icon: <DesktopOutlined aria-label="System" />,
    title: 'System',
  },
  { value: 'light', icon: <SunOutlined aria-label="Light" />, title: 'Light' },
  { value: 'dark', icon: <MoonOutlined aria-label="Dark" />, title: 'Dark' },
] satisfies { value: ThemeMode; icon: React.ReactNode; title: string }[];

const ARROW_KEYS = new Set(['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight']);

/**
 * Theme picker for the account menu, rendered as a menu group title so
 * picking an option doesn't close the menu.
 */
export const ThemeMenuRow: React.FC = () => {
  const { mode, setMode } = useThemeMode();
  return (
    // Arrow keys move between the options, not the menu items. Other keys,
    // such as Escape to close the menu, still reach the menu.
    <ThemeRow
      onKeyDown={(e) => {
        if (ARROW_KEYS.has(e.key)) e.stopPropagation();
      }}
    >
      <ThemeLabel>Theme</ThemeLabel>
      <Segmented<ThemeMode>
        size="small"
        aria-label="Theme"
        options={THEME_OPTIONS}
        value={mode}
        onChange={setMode}
      />
    </ThemeRow>
  );
};

const ThemeRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

const ThemeLabel = styled.span`
  color: var(--nav-text);
  font-size: 14px;
`;
